import * as types from '../constants/ActionTypes';

const initialState = {
  isLoading: false,
  error: false,
  hasChatBotResponse: false,
  chatBotClicked: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.REQUEST_CHAT_BOT_SESSION:
      return Object.assign({}, state, { isLoading: true, error: false, hasChatBotResponse: false });
    case types.RECEIVE_CHAT_BOT_SESSION_RESULT:
      return Object.assign({}, state, { isLoading: false, hasChatBotResponse: true });
    case types.CATCH_CHAT_BOT_SESSION_ERROR:
      return Object.assign({}, state, { isLoading: false, error: true });
    case types.CHATBOT_CLICKED:
      return Object.assign({}, state, { chatBotClicked: true });
    case types.CHATBOT_CLICKED_FALSE:
      return Object.assign({}, state, { chatBotClicked: false });
    default:
      return state;
  }
}
